module.exports = __webpack_public_path__ + "static/img/92-2.033ea85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/92-2.jpg
// module id = nVcZ
// module chunks = 0